import { Injectable, inject, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class InternetConnectionStatusService {
  snack = inject(MatSnackBar);
  isOffline = signal(false);
  /**
   *
   */
  constructor() {
    addEventListener('offline', () => {
      this.isOffline.set(true);
      this.snack.open('Switch to offline mode', 'Dismiss');
    });
    addEventListener('online', () => {
      this.snack.open('Deactivate Offline Mode', 'Dismiss');
      this.isOffline.set(false);
    });
  }
}
